import { first } from "rxjs/operators";
import {
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Component, Input, OnInit } from "@angular/core";
import { AlertService } from "@app/_services";
import {
  LazyLoadEvent,
  MessageService,
  ConfirmationService,
} from "primeng/api";
import { EmployeeAcqPayment } from "../employee-acq-payment";
import { EmployeeAcqPaymentService } from "../employee-acq-payment.service";
import { EmployeeAcqPaymentComponent } from "../employee-acq-payment/employee-acq-payment.component";
import { PropertyProfileService } from "@app/_components/property-profile/property-profile.service";
import { RealtorProfileService } from "@app/_components/realtor-profile/realtor-profile.service";
import { EmployeeProfileService } from "@app/_components/employee-profile/employee-profile.service";

@Component({
    selector: "app-employee-acq-payment-list",
    templateUrl: "./employee-acq-payment-list.component.html",
    styleUrls: ["./employee-acq-payment-list.component.css"],
    providers: [
        MessageService,
        ConfirmationService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ],
    // make column heading sticky
    styles: [
        `
      :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
      }

      @media screen and (max-width: 64em) {
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
          top: 99px;
        }
      }
    `,
    ],
    standalone: false
})
export class EmployeeAcqPaymentListComponent implements OnInit {
  employeeProfilesList: any[]=[];
  realtorProfilesList: any[]=[];
  propertyProfilesList: any[]=[];
  employeeAgnt1List: any[]=[];
  employeeAgnt2List: any[]=[];
  constructor(
    private employeeAcqPaymentService: EmployeeAcqPaymentService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private propertyProfileService: PropertyProfileService,
    private realtorProfileService: RealtorProfileService,
    private employeeProfileService: EmployeeProfileService,
    private dialog: MatDialog
  ) {
    this.statuses = employeeAcqPaymentService.statuses;
  }

  // data
  @Input() showFilter = true;
  @Input() showPagination = true;
  // @Input() outlineNewButton = true;
  employeeAcqPayments: any;
  employeeAcqPayment: EmployeeAcqPayment;

  // paging
  first = 0;
  rows = 50;

  // list
  datasource: any;

  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];

  // forms
  formLoading = false;

  statuses: any;

  columns: any[] = [
    { field: "propertyProfileId", header: "Property Name", width: "auto" },
   
    { field: "propertyProfileVO.contractSignDate", header: "Contract Sign Date", width: "auto" },
    {
      field: "agnt1UserVO.firstName",
      header: "Agent 1 Name",
      width: "auto",
    },
    {
      field: "agnt2UserVO.firstName",
      header: "Agent 2 Name",
      width: "auto",
    },    
    { field: "realtorProfileId", header: "Realtor Name", width: "auto" },
    { field: "estGrossRev", header: "Est Gross Rev", width: "auto" },
    { field: "compAcqAgent1PayDate1", header: "Payment 1 Date", width: "auto" },
    { field: "compAcqAgent1PayDate1Amount", header: "Payment 1 Amount", width: "auto" },
    { field: "compAcqAgent1PayDate1Status", header: "Payment 1 Status", width: "auto" },
    { field: "compAcqAgent1PayDate2", header: "Payment 2 Date", width: "auto" },
    { field: "compAcqAgent1PayDate2Amount", header: "Payment 2 Amount", width: "auto" },
    { field: "compAcqAgent1PayDate2Status", header: "Payment 2 Status", width: "auto" },
  ];

  ngOnInit(): void {
    this.fetchEmployeeProfiles();
    this.fetchRealtorProfiles();
    this.fetchPropertyProfiles();
    try {
      // default sort of list
      this.multiSortMeta = [];
      this.multiSortMeta.push({ field: "createDate", order: 0 });
    } catch (error) {
      console.log("Error: " + error);
    }
  }

  /*********
   * Delete Button
   *
   */
  onRowDelete(event: any) {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " +
        event.employeeAcqPaymentId +
        "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete(event);
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  /*********
   * Lazy Load All Data
   *
   */
  loadLazy(event: LazyLoadEvent) {
    try {
      this.loading = true;
      this.lazyLoadEvent = event;

      console.log(
        " event.first:" +
          event.first +
          "  |  event.rows:" +
          event.rows +
          "  |  event.sortField:" +
          event.sortField +
          "  |  event.sortOrder:" +
          event.sortOrder +
          "  |  event.multiSortMeta:" +
          JSON.stringify(event.multiSortMeta) +
          "  |  event.globalFilter:" +
          event.globalFilter +
          "  |  event.filters:" +
          JSON.stringify(event.filters)
      );

      /*
       *
       * Default Sort
       */
      // https://stackoverflow.com/questions/679915/how-do-i-employeeAcqPayment-for-an-empty-javascript-object
      // if we are NOT filtering and we are NOT sorting, apply a default sort
      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: "createDate", order: -1 });
      }

      const pageNumber = Math.round(event.first / event.rows);
      this.employeeAcqPaymentService
        .findByFilter(
          pageNumber,
          event.rows,
          event.sortField,
          event.sortOrder,
          event.multiSortMeta,
          event.globalFilter,
          event.filters
        )
        .pipe(first())
        .subscribe(
          (res: any) => {
            this.datasource = res.data.reviews;
            this.recordTotal = res.page.recordTotal;
            this.employeeAcqPayments = res.data.employeeAcqPayments;
            this.employeeAcqPayments.forEach(employeeAcqPayment => {
              if(employeeAcqPayment?.agnt1 != undefined){
                var existEmployeeCheck = false;
                this.employeeAgnt1List.forEach(agent1 => {
                  if(employeeAcqPayment?.agnt1?.userId == agent1?.userId){
                    existEmployeeCheck = true;
                  }
                });

                if(existEmployeeCheck == false){
                  this.employeeAgnt1List.push(employeeAcqPayment.agnt1);
                }
              }
              if(employeeAcqPayment?.agnt2 != undefined){
                var existEmployeeCheck = false;
                this.employeeAgnt2List.forEach(agent2 => {
                  if(employeeAcqPayment?.agnt2?.userId == agent2?.userId){
                    existEmployeeCheck = true;
                  }
                });

                if(existEmployeeCheck == false){
                  this.employeeAgnt2List.push(employeeAcqPayment.agnt2);
                }
                
              }
          });
            console.log(JSON.stringify(res.page));
          },
          (err: any) => {
            console.log("reviews list error!: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
            this.loading = false;
          }
        );

      if (this.datasource) {
        this.employeeAcqPayments = this.datasource.slice(
          event.first,
          event.first + event.rows
        );
      }
    } catch (error) {
      console.log("loadLazy(" + event + ")" + error);
    }
  }

  getStatus() {
    return;
  }

  /*********
   * onRowSelect()
   * Used to handle row click (to edit, link, etc)
   */
  onRowSelect(event: any) {
    console.log("onRowSelect: " + JSON.stringify(event));
    this.onOpenFormEdit(event.data);
  }

  // handled in rate-bucket-form
  formAdd() {}

  /*********
   * formUpdate()
   * Used for row editing
   */
  formUpdate(employeeAcqPayment: EmployeeAcqPayment) {
    try {
      this.formLoading = true;
      this.employeeAcqPaymentService.update(employeeAcqPayment).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Update SUCCESS: " + JSON.stringify(res));
          this.employeeAcqPayments.map((employeeAcqPayment, i) => {
            if (
              employeeAcqPayment.employeeAcqPaymentId ===
              res.data.employeeAcqPayment.employeeAcqPaymentId
            ) {
              this.employeeAcqPayments[i] = res.data.employeeAcqPayment;
            }
          });
          // this.alertService.success(res, true);
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Update FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: JSON.stringify(err),
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * formDelete()
   * Used for row editing
   */
  formDelete(employeeAcqPayment: any) {
    try {
      // stop here if form is invalid
      console.log("Delete Submitted: " + JSON.stringify(employeeAcqPayment));

      this.formLoading = true;
      this.employeeAcqPaymentService
        .delete(employeeAcqPayment.employeeAcqPaymentId)
        .subscribe(
          (res: any) => {
            console.log("Rate-Bucket-Delete SUCCESS: " + JSON.stringify(res));
            this.employeeAcqPayments.splice(
              this.employeeAcqPayments.indexOf(employeeAcqPayment),
              1
            );
            this.recordTotal = this.employeeAcqPayments.length;
            this.messageService.add({
              severity: "success",
              summary: "Successful",
              detail:
                "EmployeeAcqPayment " +
                employeeAcqPayment.employeeAcqPaymentId +
                " Deleted",
              life: 3000,
            });
          },
          (err: any) => {
            console.log("Rate-Bucket-Delete  FAIL: " + JSON.stringify(err));
            this.messageService.add({
              severity: "error",
              summary: "Delete Failed",
              detail:
                "EmployeeAcqPayment " +
                employeeAcqPayment.employeeAcqPaymentId +
                " could not be deleted.  Be sure there are no assigned properties to this bucket.",
              life: 3000,
            });
          },
          () => {
            this.formLoading = false;
          }
        );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * Add New Button
   *
   */
  onOpenFormAdd() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: "Add EmployeeAcqPayment",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(
      EmployeeAcqPaymentComponent,
      dialogConfig
    );

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.addEmployeeAcqPaymentCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /*********
   * Edit Button
   *
   */
  onOpenFormEdit(employeeAcqPayment: EmployeeAcqPayment) {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      employeeAcqPayment: employeeAcqPayment,
      title: "Edit EmployeeAcqPayment",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(
      EmployeeAcqPaymentComponent,
      dialogConfig
    );

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.updateEmployeeAcqPaymentCB(data);

      // close the dialogBox
      dialogRef.close();
    });

    dialogRef.componentInstance.doDelete.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.deleteEmployeeAcqPaymentCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /**
   *
   * Dialog from Form Callbacks
   * To edit the list show add/edit/delete in real time from the popup form
   *
   */
  addEmployeeAcqPaymentCB(employeeAcqPayment: EmployeeAcqPayment) {
    console.log(
      "Adding EmployeeAcqPayment: " + JSON.stringify(employeeAcqPayment)
    );
    // if we don't have a employeeAcqPayments array yet...
    if (!this.employeeAcqPayments) {
      this.employeeAcqPayments = [];
    }
    // unshift adds to the front of the array (), push adds to the back
    this.employeeAcqPayments.unshift(employeeAcqPayment);

    // no idea what this is but it is required to update the array
    this.employeeAcqPayments = [...this.employeeAcqPayments];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail:
        "EmployeeAcqPayment " +
        employeeAcqPayment.employeeAcqPaymentId +
        " Added",
      life: 3000,
    });
  }

  updateEmployeeAcqPaymentCB(employeeAcqPayment: EmployeeAcqPayment) {
    console.log(
      "Updating EmployeeAcqPayment: " + JSON.stringify(employeeAcqPayment)
    );
    let itemIndex = this.employeeAcqPayments.findIndex(
      (item: any) =>
        item.employeeAcqPaymentId === employeeAcqPayment.employeeAcqPaymentId
    );
    this.employeeAcqPayments[itemIndex] = employeeAcqPayment;

    // no idea what this is but it is required to update the array
    this.employeeAcqPayments = [...this.employeeAcqPayments];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail:
        "EmployeeAcqPayment " +
        employeeAcqPayment.employeeAcqPaymentId +
        " Updated",
      life: 3000,
    });
  }

  deleteEmployeeAcqPaymentCB(employeeAcqPayment: EmployeeAcqPayment) {
    console.log("Removing EmployeeAcqPayment: " + employeeAcqPayment);
    this.employeeAcqPayments.splice(
      this.employeeAcqPayments.indexOf(employeeAcqPayment),
      1
    );
    this.recordTotal = this.employeeAcqPayments.length;

    // no idea what this is but it is required to update the array
    this.employeeAcqPayments = [...this.employeeAcqPayments];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail:
        "EmployeeAcqPayment " +
        employeeAcqPayment.employeeAcqPaymentId +
        " Deleted",
      life: 3000,
    });
  }

  /**********
   *
   * PAGINATOR FUNCTIONS
   */
  next() {
    this.first = this.first + this.rows;
  }
  prev() {
    this.first = this.first - this.rows;
  }
  reset() {
    this.first = 0;
  }
  isLastPage(): boolean {
    return this.employeeAcqPayments
      ? this.first === this.employeeAcqPayments.length - this.rows
      : true;
  }
  isFirstPage(): boolean {
    return this.employeeAcqPayments ? this.first === 0 : true;
  }

  get Statuses() {
    return this.statuses;
  }

  getStatusName(employeeAcqPayment: any) {
    if (employeeAcqPayment?.compAcqSchedPay1Status) {
      const status = this.statuses.find(
        (e: any) => e.value == employeeAcqPayment.compAcqSchedPay1Status
      );
      return status?.name;
    } else {
      return "";
    }
  }

  getPropertyName(employeeAcqPayment: any) {
    if (employeeAcqPayment?.propertyProfileId) {
      const status = this.propertyProfilesList.find(
        (e: any) => e.propertyProfileId == employeeAcqPayment.propertyProfileId
      );
      return status?.propertyName;
    } else {
      return "";
    }
  }

  getContractDate(employeeAcqPayment: any) {
    if (employeeAcqPayment?.propertyProfileId) {
      const status = this.propertyProfilesList.find(
        (e: any) => e.propertyProfileId == employeeAcqPayment.propertyProfileId
      );
      return status?.contractSignDate;
    } else {
      return "";
    }
  }

  getEstGrossRev(employeeAcqPayment: any) {
    if (employeeAcqPayment?.propertyProfileId) {
      const status = this.propertyProfilesList.find(
        (e: any) => e.propertyProfileId == employeeAcqPayment.propertyProfileId
      );
      return status?.estGrossRev;
    } else {
      return "";
    }
  }

  getAgent1Name(employeeAcqPayment: any) {
    if (employeeAcqPayment?.agent1EmployeeProfileId) {
      const status = this.employeeProfilesList.find(
        (e: any) => e.employeeProfileId == employeeAcqPayment.agent1EmployeeProfileId
      );
      return status?.firstName;
    } else {
      return "";
    }
  }

  getAgent2Name(employeeAcqPayment: any) {
    if (employeeAcqPayment?.agent2EmployeeProfileId) {
      const status = this.employeeProfilesList.find(
        (e: any) => e.employeeProfileId == employeeAcqPayment.agent2EmployeeProfileId
      );
      return status?.firstName;
    } else {
      return "";
    }
  }

  getRealtorName(employeeAcqPayment: any) {
    if (employeeAcqPayment?.realtorProfileId) {
      const status = this.realtorProfilesList.find(
        (e: any) => e.realtorProfileId == employeeAcqPayment.realtorProfileId
      );
      return status?.firstName;
    } else {
      return "";
    }
  }

  reloadPage() {
    window.location.reload();
  }

  showPaginator() {
    return true;
  }

  fetchPropertyProfiles(){
		try {
			this.propertyProfileService.findAllForRequiredFields()
				.subscribe(
					res => {
						 console.log('findAllPropertyProfile: ' + JSON.stringify(res));
						this.propertyProfilesList = res.data.propertyProfiles;
						return this.propertyProfilesList;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

  // get all realtor profiles
	fetchRealtorProfiles(){
		try {
			this.realtorProfileService.findAllForRequiredFields()
				.subscribe(
					res => {
						 console.log('findAllRealtorProfiles: ' + JSON.stringify(res));
						this.realtorProfilesList = res.data.realtorProfiles;
						return this.realtorProfilesList;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

   // get all realtor profiles
	fetchEmployeeProfiles(){
		try {
			this.employeeProfileService.findAllForRequiredFields()
				.subscribe(
					res => {
						 console.log('findAllEmployeeProfilesList: ' + JSON.stringify(res));
						this.employeeProfilesList = res.data.employeeProfiles;
						return this.employeeProfilesList;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
}
